import { StandardQuizQuestion } from '@/types/quizTypes';

export const JS_FUNCTIONS_QUIZ: StandardQuizQuestion[] = [
  {
    id: "js-func-1",
    question: "What is the main difference between function declarations and arrow functions?",
    options: [
      "Arrow functions are faster",
      "Arrow functions don't have their own 'this' binding",
      "Function declarations can't return values",
      "Arrow functions can't take parameters"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Arrow functions inherit 'this' from their enclosing scope (lexical binding), while regular functions have their own 'this' context that depends on how they're called.",
    category: "arrow-functions",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "js-func-2",
    question: "What will this function return? `const add = (a, b = 5) => a + b; add(3);`",
    options: [
      "3",
      "8",
      "undefined",
      "NaN"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "The parameter 'b' has a default value of 5. When add(3) is called, a=3 and b uses the default value of 5, so the result is 8.",
    category: "parameters",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "js-func-3",
    question: "What is a closure in JavaScript?",
    options: [
      "A function that closes the browser",
      "A function that has access to variables in its outer scope",
      "A function without parameters",
      "A function that returns undefined"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "A closure is a function that retains access to variables from its outer (enclosing) scope even after the outer function has returned. This enables data privacy and stateful functions.",
    category: "closures",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "js-func-4",
    question: "What does 'hoisting' mean for function declarations?",
    options: [
      "Functions are deleted before execution",
      "Functions are moved to the top of their scope during compilation",
      "Functions run faster",
      "Functions can only be called once"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Function declarations are hoisted to the top of their scope, meaning you can call them before they appear in the code. Arrow functions and function expressions are not hoisted the same way.",
    category: "scope",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "js-func-5",
    question: "What is a callback function?",
    options: [
      "A function that calls itself",
      "A function passed as an argument to another function",
      "A function that returns a function",
      "A function without a name"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "A callback is a function passed as an argument to another function, to be executed later. Common in asynchronous operations and event handling.",
    category: "callbacks",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "js-func-6",
    question: "What will `(function() { return 'IIFE'; })()` output?",
    options: [
      "undefined",
      "'IIFE'",
      "Error",
      "null"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "This is an Immediately Invoked Function Expression (IIFE). The function is defined and executed immediately, returning 'IIFE'.",
    category: "iife",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "js-func-7",
    question: "What does the rest parameter (...args) do?",
    options: [
      "Stops function execution",
      "Collects remaining arguments into an array",
      "Spreads an array into individual elements",
      "Creates a copy of arguments"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "The rest parameter (...args) collects all remaining function arguments into an array, allowing functions to accept an indefinite number of arguments.",
    category: "parameters",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "js-func-8",
    question: "What is a higher-order function?",
    options: [
      "A function that runs faster",
      "A function that takes a function as argument or returns a function",
      "A function with many parameters",
      "A function at the top of the file"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Higher-order functions either accept functions as arguments or return functions. Examples include map, filter, reduce. They enable functional programming patterns.",
    category: "advanced",
    points: 20,
    type: "multiple-choice"
  }
];

export const generateJsFunctionsQuiz = () => ({
  questions: JS_FUNCTIONS_QUIZ,
  passThreshold: 80,
  timeLimit: 600,
  category: 'javascript-functions'
});
